import { Box, Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { Trash2Icon } from 'lucide-react';
import { ChangelogItemCreate } from '../../types/Changelog/ChangelogCreate.type';
import { ChangelogItemType } from '../../types/Changelog/ChangelogItemType.type';
import { Team } from '../../types/Team/Team.type';
import TeamsMultiSelect from './TeamsMultiSelect';

interface ChangelogItemFormProps {
  item: ChangelogItemCreate;
  index: number;
  teams: Team[];
  types: ChangelogItemType[];
  onChange: (index: number, item: ChangelogItemCreate) => void;
  onRemove: (index: number) => void;
  removable: boolean;
}

function ChangelogItemForm({ item, index, teams, types, onChange, onRemove, removable }: ChangelogItemFormProps) {
  const handleField = <K extends keyof ChangelogItemCreate>(field: K, value: ChangelogItemCreate[K]) => {
    onChange(index, { ...item, [field]: value });
  };

  return (
    <Box
      sx={{
        border: '1px solid #cbd5e0',
        backgroundColor: '#fff',
        borderRadius: 1,
        padding: 2,
        paddingY: 3,
      }}
    >
      <Stack spacing={2}>
        <TextField
          type='text'
          label='Title'
          variant='outlined'
          value={item.title}
          onChange={(e) => handleField('title', e.target.value)}
          sx={{ '& .MuiInputLabel-root': { fontSize: 14 } }}
        />
        <TextField
          type='text'
          label='Description'
          variant='outlined'
          multiline
          minRows={2}
          value={item.description}
          onChange={(e) => handleField('description', e.target.value)}
          sx={{ '& .MuiInputLabel-root': { fontSize: 14 } }}
        />
        <FormControl>
          <InputLabel id={`select-type-label-${index}`} sx={{ fontSize: '14px' }}>
            Select a type
          </InputLabel>
          <Select
            variant='outlined'
            labelId={`select-type-label-${index}`}
            value={item.type_id ? item.type_id.toString() : ''}
            label='Select a type'
            onChange={(e) => handleField('type_id', Number(e.target.value))}
          >
            {types.map((type) => (
              <MenuItem key={type.id} value={type.id}>
                {type.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TeamsMultiSelect
          teams={teams}
          value={item.team_ids}
          onChange={(teamIds) => handleField('team_ids', teamIds)}
        />
      </Stack>
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          justifyContent: 'end',
          marginTop: 3,
        }}
      >
        {removable && (
          <Button
            variant='outlined'
            color='error'
            size='small'
            startIcon={<Trash2Icon size={16} />}
            onClick={() => onRemove(index)}
          >
            Remove item
          </Button>
        )}
      </Stack>
    </Box>
  );
}

export default ChangelogItemForm;
